module.exports = __webpack_public_path__ + "static/media/sea-of-cowards.3ac8f2cc.jpg";